import {Component, Inject, LOCALE_ID, Renderer2} from '@angular/core';
import {Locales, MenuTypeKey, MenuTypes, ThemeKey} from "../../../../models/global.config";
import {LocalStorageService} from "../../../../base/services/storage/localstorage.service";
import {MENU} from "../left-nav/menu.model";

@Component({
  selector: 'app-dash-layout',
  templateUrl: './dash-layout.component.html',
  styleUrls: ['./dash-layout.component.scss']
})
export class DashLayoutComponent {

  protected readonly MENU = MENU;
  protected readonly Locales = Locales;
  menuType = MenuTypes.VERTICAL
  theme = "light";

  constructor(
    @Inject(LOCALE_ID) protected locale: string,
    private renderer: Renderer2
  ) {

    LocalStorageService.retrieveAsync(ThemeKey.DASHBOARD, (theme) => {
      this.setTheme(theme as string)
    })

    LocalStorageService.retrieveAsync(MenuTypeKey.DASHBOARD, (mt) => {
      this.menuType = (mt as MenuTypes) || MenuTypes.VERTICAL
    })
  }

  setTheme(theme: string) {
    this.theme = theme;
    this.renderer.setAttribute(document.documentElement, 'data-bs-theme', this.theme)
    this.renderer.setAttribute(document.body, 'data-sidebar', this.theme)
  }

}
